// Secondary accessory: Pendleton flannel plaid pattern.
// Used as fabric texture overlay for La Clica cards (and on cholo-faction
// secondaries). Reads as the woolen flannel — the everyday Chicano garment.

interface PendletonPatternProps {
  /** Primary color (warp threads). */
  bodyColor?: string;
  /** Cross-stripe color (weft threads). */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function PendletonPattern({
  bodyColor = '#ff8a3d',
  accentColor = '#141008',
  size = 48,
  className,
}: PendletonPatternProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Background swatch — the Pendleton color */}
      <rect x="0" y="0" width="48" height="48" rx="2" fill={bodyColor} />
      {/* Horizontal stripes — flannel weave */}
      <rect x="0" y="6" width="48" height="2" fill={accentColor} opacity="0.6" />
      <rect x="0" y="18" width="48" height="3" fill={accentColor} opacity="0.7" />
      <rect x="0" y="30" width="48" height="2" fill={accentColor} opacity="0.6" />
      <rect x="0" y="42" width="48" height="3" fill={accentColor} opacity="0.7" />
      {/* Vertical stripes — crosshatch */}
      <rect x="6" y="0" width="2" height="48" fill={accentColor} opacity="0.5" />
      <rect x="18" y="0" width="3" height="48" fill={accentColor} opacity="0.65" />
      <rect x="30" y="0" width="2" height="48" fill={accentColor} opacity="0.5" />
      <rect x="42" y="0" width="3" height="48" fill={accentColor} opacity="0.65" />
      {/* Diagonal accent — single thread to imply weave detail */}
      <line x1="0" y1="0" x2="48" y2="48" stroke={accentColor} strokeWidth="0.5" opacity="0.3" />
    </svg>
  );
}
